import sensorInitialize from '../sensor-wrapper/src';
    
import autoCompleteEnhancer from './autoCompleteEnhancer';
const fields = require('./config/fields.json');
const eventFieldsMap = require('./config/eventFieldsMap.json');

export default sensorInitialize(
    eventFieldsMap,
    fields,
    autoCompleteEnhancer,
    {
        debug: true
    }
);



// WEBPACK FOOTER //
// ./common/Utils/Sensor/index.js